module.exports = __webpack_public_path__ + "static/media/slideshow-foto-03.48db18e7.png";